module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.10550/assets/images/descript.jpg"